<script lang="ts" setup>
  import { ref } from 'vue'
  import type { Tab } from './BaseTabs.types'
  import { TAB_CHANGE_EVENT_NAME, TEST_ID, TAB_INPUT_TEST_ID } from './BaseTabs.constants'

  interface Props {
    modelValue?: string
    tabs: Tab[]
    size: 'small' | 'big'
  }

  interface Emits {
    (e: 'update:modelValue', value: string): void
    (e: typeof TAB_CHANGE_EVENT_NAME, tab: string): void
  }

  const props = withDefaults(defineProps<Props>(), {
    tabs: () => [],
    size: 'big',
  })
  const emit = defineEmits<Emits>()

  const activeTab = ref(props.modelValue ?? props.tabs[0].id)

  const onChange = () => {
    emit('update:modelValue', activeTab.value)
    emit(TAB_CHANGE_EVENT_NAME, activeTab.value)
  }
</script>

<template>
  <div class="base-tabs" :class="`base-tabs-${size}`" :data-testid="TEST_ID">
    <div v-for="tab of props.tabs" :key="tab.id">
      <slot name="tab" v-bind="tab">
        <input
          v-model="activeTab"
          type="radio"
          name="tab"
          :value="tab.id"
          :id="tab.id"
          :data-testid="TAB_INPUT_TEST_ID"
          @change="onChange"
        />
        <label class="base-tabs__tab" :for="tab.id">
          <div class="base-tabs__title">{{ tab.title }}</div>
          <div class="base-tabs__subtitle">{{ tab.subtitle }}</div>
        </label>
      </slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import './BaseTabs';
</style>
